export const routes = {
  base: '/in-meeting-experience-ui-components',
  outsideMeeting: '/outside-active-meeting',
  reconnect: '/reconnect',
  draft: '/draft',
  contacts: '/contacts',
  accounts: '/accounts',
  acceptanceTestBaseRoute: '/acceptance-tests' // mock value for TS
};
export const unauthorizedRoutesParam = 'autoRedirect';
export const repeatedVisitKey = 'isRepeatedVisit';